import { render, staticRenderFns } from "./MainSpecialEquipments.vue?vue&type=template&id=b35046ee&scoped=true&"
import script from "./MainSpecialEquipments.vue?vue&type=script&lang=js&"
export * from "./MainSpecialEquipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35046ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b35046ee')) {
      api.createRecord('b35046ee', component.options)
    } else {
      api.reload('b35046ee', component.options)
    }
    module.hot.accept("./MainSpecialEquipments.vue?vue&type=template&id=b35046ee&scoped=true&", function () {
      api.rerender('b35046ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/views/special-equipments/MainSpecialEquipments.vue"
export default component.exports